var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3Active(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.994,
    height: 48.873,
    viewBox: "0 0 49.994 48.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 41.155,
    height: 39.569,
    fill: "#66aa47"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3_-_Active",
    "data-name": "3 - Active",
    transform: "translate(-938.003 -213.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 948.244, 213.281)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M27.218,16.455c1.047-.174,2.032-.386,3.028-.494a15.83,15.83,0,0,1,6.074.169,6.6,6.6,0,0,1,4.58,8.061,5.78,5.78,0,0,1-1.7,2.528c-2.135,1.993-1.787,1.392-2.074,4.29-.27,2.726-1.756,4.444-4.906,5.192-2.911.691-5.161-.608-6.963-2.8a24.272,24.272,0,0,1-3.864-6.641c-.037-.1-.1-.182-.229-.424-.1,1.176-.145,2.192-.285,3.194-.449,3.2-.932,6.4-1.406,9.6-.038.255-.116.469-.466.432a7.83,7.83,0,0,1-3.782-1.277A40.446,40.446,0,0,0,18.605,27c-.273.375-.539.755-.819,1.125a20.794,20.794,0,0,1-5.348,5.266,6.629,6.629,0,0,1-9.116-1.626A5.389,5.389,0,0,1,2.4,27.8c.038-.455.108-.907.171-1.36A2.432,2.432,0,0,0,2.089,24.5c-.307-.388-.579-.8-.872-1.2-1.7-2.31-1.546-4.491,0-6.962a6,6,0,0,1,5.129-2.853,18.568,18.568,0,0,1,7.26,1.572c.188.071.379.134.673.236-.5-.876-.962-1.635-1.377-2.418A17.478,17.478,0,0,1,11.012,8,6.62,6.62,0,0,1,16.5.055a5.111,5.111,0,0,1,3.094.6c2.915,1.386,2.047,1.277,4.949.415,4.391-1.305,8.143,3.2,7.615,6.9A11.874,11.874,0,0,1,29.715,13.3c-.772,1.057-1.624,2.055-2.5,3.152",
    transform: "translate(0 0)",
    fill: "#66aa47"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(958.5 241.835)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Active);
export default __webpack_public_path__ + "static/media/3 - Active.85270e1cfceac86b4b1bf617a3026b3a.svg";
export { ForwardRef as ReactComponent };